import { render, staticRenderFns } from "./ViewEditClinicOnboardingUploadedImages.vue?vue&type=template&id=0fc04961&scoped=true&"
import script from "./ViewEditClinicOnboardingUploadedImages.vue?vue&type=script&lang=js&"
export * from "./ViewEditClinicOnboardingUploadedImages.vue?vue&type=script&lang=js&"
import style0 from "./ViewEditClinicOnboardingUploadedImages.vue?vue&type=style&index=0&id=0fc04961&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc04961",
  null
  
)

export default component.exports